import styled from 'styled-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const Video = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  height: 180px;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #ccc;
  overflow: hidden;
`;

export const Preview = styled(Flex).attrs({
  flex: '50%',
  spacing: 10,
  column: true,
  align: 'center',
  justify: 'center',
})`
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`;

export const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  margin: none;
  background: none;
`;


export const PlayIcon = styled.div`
  cursor: pointer;
  height: 44px;
  width: 44px;
  background-color: rgba(255,255,255,0.7);
  border-radius: 44px;
  overflow: hidden;
  background-image: url(${icons.videoPlay});
  background-repeat: no-repeat;
  background-position: center;
`;

export const Details = styled(Flex).attrs({
  flex: '50%',
  spacing: 10,
  column: true,
})`
  padding: 15px;
`;

export const Report = styled.div`
  background: url(${icons.videoFlag});
  background-size: contain;
  background-repeat: no-repeat;
  height: 10px;
  width: 10px;
  position: absolute;
  right: 10px;
  top: 17px;
  cursor: pointer;
`;

export const VideoType = styled(Flex).attrs({
  spacing: 5,
  align: 'center',
})`
  color: #808080;
  font-size: 13px;
  line-height: 18px;
  text-transform: capitalize;
`;
